import { $ } from "@/common/Axios";

export default {
  /**
   * 技能培训班级
   */
  skillClass: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseIds 课程id (string query )
     * endTime 结束时间 (string query )
     * headerTeacherId 班主任 (integer query )
     * id  (integer query )
     * name 班级名称 (string query )
     * siteId 学校id (integer query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/cms/skill/skillClass", p, c),

    /*
     * 删除
     * id 班级id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/skill/skillClass", p, c),
  },
  skillClass_getCourseId: {
    /*
     * 获取课程id（已关联的）
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/getCourseId", p, c),
  },
  skillClass_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/list", p, c),
  },
  skillClass_listSimple: {
    /*
     * 简易
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillClass/listSimple", p, c),
  },
  skillClass_setCourseId: {
    /*
     * 设置课程id
     * classId 班级id (integer query required)
     * courseIds 课程id (array query required)
     */
    put: (p, c) => $.put("/api/cms/skill/skillClass/setCourseId", p, c),
  },

  /**
   * 技能培训学生
   */
  skillStudent: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/skill/skillStudent", p, c),
  },
  skillStudent_assignClass: {
    /*
     * 分班
     * classId 班级id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) => $.put("/api/cms/skill/skillStudent/assignClass", p, c),
  },
  skillStudent_edit: {
    /*
     * 编辑（上传证书或者修改成绩）
     * cert 证书 (string query )
     * id id (integer query required)
     * score 成绩 (integer query )
     */
    put: (p, c) => $.put("/api/cms/skill/skillStudent/edit", p, c),
  },
  skillStudent_export: {
    /*
     * 导出
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/skill/skillStudent/export", p, c),
  },
  skillStudent_getIdByClassAndIdCardNo: {
    /*
     * 通过班级id和身份证查询id
     * classId 班级id (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/skill/skillStudent/getIdByClassAndIdCardNo", p, c),
  },
  skillStudent_list: {
    /*
     * 列表
     * classId 班级id (integer query )
     * name 姓名 (string query )
     * schoolRollId 合同id (integer query )
     */
    get: (p, c) => $.get("/api/cms/skill/skillStudent/list", p, c),
  },
  skillStudent_uploadScore: {
    /*
     * 上传成绩
     * classId 班级id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/skill/skillStudent/uploadScore", p, c),
  },
};
